import client from "services/client";

const premBotClientCreationService = async ({ accessToken, data }) => {
  client.accessToken = accessToken;

  return await client.post("/prem_bot/clients", data).catch((error) => error);
};

export default premBotClientCreationService;
